<template>
  <div class="c-page u-relative">
      <section    data-color="clear" class="u-relative u-fit-w u-bg--brand-dark u-overflow-h js-header-panel">
        <div class="c-page__header o-wrapper--panel" :style="'transform:translateX(' + headerPageSize[2] + 'px) translateY('+headerPageSize[3]+'px) scale('+headerPageSize[4]+')'" >
          <img
          src="/static/HeadImages/prunelle.jpg"
          class="u-absolute u-pos-tl"
          :style="
            'width:' +
            headerPageSize[0] +
            'px; height:' +
            headerPageSize[1] +
            'px'
          "
        />
         </div>
         <div class="o-wrapper--valign u-viewport-fit-h u-fit-w">
             <div class="u-relative u-inline-block c-top-maintitle u-pos-x-center u-align-center">
               <span class="c-page__subtitle t-hh1 t-text-ls--md t-text--roman u-color--white u-align-center  u-inline-block " v-html="contentBread.subtitle"></span>
                 <h1 class="t-h2-sub  t-text-lh--md u-color--white u-align-center  u-marg-b-lg">
                     <app-sliced-text :content="contentBread.title"></app-sliced-text>
                 </h1>
               </div>
         </div>
         <button v-scroll-to="'#start'" class="c-home__scroll-btn c-btn-scroll  u-pos-x-center t-btn u-absolute u-inline-block  u-marg-b-md@sm">
          <img src="/static/common/MainLogoWhite -arrow-white2.svg"  width="32px" >
          </button>
      </section>

      <section  :data-color="item.dataColor" v-for="(item, index)  in contentBread.blocks" class="u-relative u-overflow-h u-fit-w  u-pad-x-w1of12  u-pad-x-w1of12@sm   js-header-panel" :class="[item.bgColorClass]" >
       <span v-if="index<contentBread.blocks.length -1" class="c-line c-line--x u-absolute u-pos-bl u-bg--gray u-fit-w"></span>
            <div class="privinvest-box-page u-relative u-flex u-pad-yb0-lg@sm u-flex-fd--column@sm u-pad-t-xl u-pad-b-lg u-zindex--2" v-if="item.special==='special-left'">
              <div  v-if="index===no"    class="u-absolute u-pos-tl u-fit">
                    <div class="c-investors__section-2__pattern u-absolute u-pos-br u-w2of5 u-marg-b-0@sm u-opacity--20@sm u-w3of4@sm">
                         <img src="../../assets/medias/images/services/maintenance-marineholdings.jpg" class="u-fit-w" >
                       </div>
               </div>
               <div v-if="index===no"    class="u-absolute u-pos-tl u-fit">
                     <div class="c-investors__section-2__pattern u-absolute u-pos-br u-w2of5 u-marg-b-0@sm u-opacity--20@sm u-w3of4@sm">
                          <img src="../../assets/medias/images/services/Integrated-logistics2.jpg" class="u-fit-w" >
                        </div>
                </div>
                <div v-if="index===no"    class="u-absolute u-pos-tl u-fit">
                      <div class="c-investors__section-2__pattern u-absolute u-pos-br u-w2of5 u-marg-b-0@sm u-opacity--20@sm u-w3of4@sm">
                           <img src="../../assets/medias/images/services/Integration-ofCombatSystem.jpg" class="u-fit-w" >
                         </div>
                 </div>
              <div class="u-marg-b-xxl u-marg-b-lg@sm u-w5of8 u-w1of2@md  u-pad-l-0@lg u-fit-w@sm" :class="{'u-pad-l-w1of8':item.padLeft==='1'}">
                  <div>
                    <app-scroll-object :offset=".05" :isParallax="!1" inline-template :content="item">
                          <h3 class="t-h3 t-text--roman u-relative u-marg-r-lg   u-marg-r-0@sm" :class="{'u-color--brand-dark':item.color==='dark','u-color--white':item.color==='white'}">
                              <app-words  :isActive="isActive" :delay="0" :content="content.title"></app-words>
                            </h3>
                      </app-scroll-object>
                  </div>
                  <div :key="indexin" v-for="(itemin, indexin)  in item.content">
                      <h6 class=" t-text--md u-pad-t-lg" v-if="'title'===itemin.type.value" :class="{'t-text--md--bold':itemin.bold==='true','u-color--brand-dark':itemin.color==='dark','u-color--white':itemin.color==='white','u-color--gray':itemin.color==='gray'}">
                          <app-scroll-object   :offset=".05"  :isParallax="!1" inline-template  :content="itemin" >
                               <app-words  :isActive="isActive" :delay="0" :content="content.content"></app-words>
                           </app-scroll-object >
                        </h6>
                      <div class="u-marg-t-md t-text--ultra" v-if=" 'default'===itemin.type.value" :class="{'u-marg-t-md':indexin>0,'u-color--gray':itemin.color==='dark','u-color--white':itemin.color==='white'}" v-html="itemin.content"> </div>
                    </div>
              </div>
          </div>
          
      </section>
      <section data-color="dark" class="u-relative u-fit-w  u-overflow-h js-header-panel">


   <div class="u-relative u-fit-w">


      <div class="u-flex u-flex-fd--column@sm  u-align-left  u-pad-x-w2of12">


        <div class="c-page c-blog  u-pad-x-w1of12@sm  u-fit-w"  >
           <header  >
             <h3 class="t-h3 u-marg-t-xxl  t-text--roman u-relative u-marg-r-lg u-marg-b-lgs u-marg-r-0@smu-color--gray u-color--gray"  ref="article">
                 
                  <span class="c-number-offset2 t-text--xl--Light u-absolute u-pos-bl"  >01</span>
                  <app-sliced-text :content="'BREAD PRODUCTS'"></app-sliced-text>
              </h3>
             <div class="u-flex u-flex-fd--row  u-flex__item-as--start u-fit-w  u-marg-b-lgs u-hide@md">
               <div class="u-w12of10">&nbsp;</div>
               <div class="u-w2of5 u-w1of2@md careers-u-color--brand-bold-Title">Description</div>
              
               
              </div>
         </header>
         
         <div class="u-flex u-flex-fd--row  u-pad-y-sm   u-flex-fd--column@md  u-flex__item-as--start u-fit-w c-blog__careers u-pad-x-w0of0@xs u-w2of10"   v-if="areTherePosts"  v-for="(post,index)  in posts"   :key="post.id"   >
           <div class="u-w12of10 career-number-index u-hide@md u-color--gray--CarrerNumbering">{{post.IndexLevel+1<10?"0"+(post.IndexLevel+1):post.IndexLevel+1}}.</div>
           <div class="u-w2of2 t-text--xl u-pad-y-sm@md  u-w2of2@md careers-u-color--brand" v-html="post.title"><span class="u-hide-min@md careers-u-color--brand-bold-Title">Description: </span></div>
          
         
           
          </div>




         <div class="c-blog__article u-flex u-flex-fd--column@sm u-pad-y-xl" v-if="!areTherePosts">
           <div class="u-fit-w">
               <h2 class="t-h5 t-text--roman u-marg-b-md">{{posts[0].title}}</h2>
           </div>
         </div>
           <!---->
           <footer class="c-blog__footer u-pad-t-md u-pad-b-xxl">
              <div class="c-blog__footer__prev u-w2of10 u-uppercase">
                    <router-link v-if="currentPageIndex > 1 && 0 !== currentPageIndex" class="c-blog__footer__prev__link u-relative u-color--gray" :to="'/salameh/bread?page='+(currentPageIndex - 1)">
                       Prev
                    </router-link>
               </div>
              <div class="c-blog__footer__pagination u-w6of10">
                        <router-link v-if="currentPageIndex>3" :to="'bread?page=1'+pages[0].index" class="c-blog__footer__pagination__page u-relative u-color--gray" :class="'c-blog__footer__pagination__page--'+pages[0].index">
                       {{"0"+(pages[0].index)}}
                       </router-link>
                       <div v-if="currentPageIndex>4"  class="c-blog__footer__pagination__page" >
                         ...
                      </div>
                      <router-link v-if="indexp <= currentPageIndex + 1 && indexp >= currentPageIndex || indexp >= currentPageIndex - 3 && indexp <= currentPageIndex"  v-for="(page, indexp)  in pages" :key="page.id" class="c-blog__footer__pagination__page u-relative u-color--gray" :class="[{'is-active':page.index===currentPageIndex},'c-blog__footer__pagination__page--'+indexp]" :to="'bread?page='+ page.index">
                        {{page.index<10?"0"+page.index:page.index}}
                      </router-link>
                      <div  v-if="currentPageIndex<pages.length-3"   class="c-blog__footer__pagination__page">
                        ...
                      </div>

                      <router-link v-if="currentPageIndex < pages.length-2"  class="c-blog__footer__next__link u-relative u-color--gray" :class="['c-blog__footer__pagination__page--'+pages[pages.length-1].index]" :to="'bread?page='+ pages[pages.length-1].index">
                       {{pages[pages.length-1].index<10?"0"+pages[pages.length-1].index:pages[pages.length-1].index}}
                      </router-link>  
            </div>
              <div class="c-blog__footer__next u-w2of10 u-uppercase">
              <router-link v-if="currentPageIndex < pages.length && 0 !== currentPageIndex"  class="c-blog__footer__next__link u-relative u-color--gray"  :to="'salameh/bread?page='+ (currentPageIndex + 1)">
               Next
              </router-link>
            </div>
            </footer>
        </div>
  </div>
 </div>
</section>
  <app-footer :globalContent="globalContent" :adminContent="adminContent"  :newsletterShown="!1" :careersShown="!0"></app-footer>
  </div>

</template>

<script>
import {format, compareAsc} from 'date-fns'
import AppFooter from  '../app-footer/index.vue'
import  AppSlicedText from '../app-sliced-text/index.vue'
import {getAbsoluteBoundingRect}  from '../../utilities/getAbsoluteBoundingRect.js'
export default
{
          components:{
                                    "app-sliced-text":AppSlicedText,
                                    "app-footer":AppFooter
                    },
                  props: {
                      adminContent: {
                          type: Object,
                          default: function() {}
                      },
                      globalContent: {
                          type: Object,
                          default: function() {}
                      },
                      headerPageSize: {
                          type: Array,
                          default: function() {}
                      }
                  },
                  data: function() {
                      return {
                          areTherePosts: !1,
                            imageHeadSrc:''
                      }

                  },
                  computed:
                  {
                     contentBread: function()
                     {
                         return  this.adminContent.en.BreadProducts
                     },
                      computedPosts: function()
                      {
                          var t = [];
                          if (this.$route.query.page)
                          {

                              if (Object.keys(this.adminContent.en.bread_products).length > 0)
                              {
                                  if (this.adminContent.en.bread_products[this.$route.query.page])
                                  {
                                      this.areTherePosts = !0;
                                      var blockIndex=(parseInt(this.$route.query.page)-1)*4;

                                      for (var e = 0, n = this.adminContent.en.bread_products[this.$route.query.page].length; e < n; e += 1)
                                      {

                                          var r = this.adminContent.en.bread_products[this.$route.query.page][e];
                                          r.IndexLevel=blockIndex+e;
                                          r.dateFormated = {
                                              //day: format(r.post_wp.post_date, "DD"),
                                            //  month: format(r.post_wp.post_date, "MMMM"),
                                            //  year: format(r.post_wp.post_date, "YY")
                                          },
                                           t.push(r)
                                      }
                                  }
                                  else
                                  {
                                   this.areTherePosts = !1,
                                   t.push({
                                      title: "Error - Page not found",
                                      first_paragraph_shorted: "Incorrect page number. <br /> Please click on one of the page numbers below.",
                                      dateFormated: {
                                          day: 404,
                                          month: "",
                                          year: ""
                                      }
                                  })
                                }
                              }
                          }
                          else
                          {
                          this.areTherePosts = !1, t.push({
                              title: "No recents announcements yet.",
                              first_paragraph_shorted: "",
                              dateFormated: {
                                  day: "",
                                  month: "",
                                  year: ""
                              }
                          })
                        }
                          return t
                      },
                      computedPages: function()
                      {
                          var t = [];
                          if (this.$route.query.page)
                          {
                              t.length = 0;
                              for (var e = 0, n = Object.keys(this.adminContent.en.bread_products).length; e < n; e += 1)
                              {
                                  var r = Object.keys(this.adminContent.en.bread_products)[e];
                                  t.push({
                                      index: parseInt(r, 10),
                                      isVisible: !0
                                  })
                              }
                          }
                          return t
                      },
                      computedCurrentPageIndex: function()
                      {
                          var t = 1;
                          return this.$route.query.page && (t = this.adminContent.en.bread_products[this.$route.query.page] ? parseInt(this.$route.query.page, 10) : 0), t
                      }

                      ,
                      myStylesTransform2() {
                        return {
                            transform: 'translateX('+this.headerPageSize[2]+'px) translateY('+this.headerPageSize[3]+'px) scale('+this.headerPageSize[4]+')'

                        }

                    },
                    myStylesWidthHeight() {
                       return {
                         width: this.headerPageSize[0] + "px",
                         height: this.headerPageSize[1] + "px"

                       }
                   }

                  },
                  beforeCreate: function()
                  {
                      this.$route.query.page || this.$router.push("/salameh/bread?page=1")
                  },
                  created: function()
                  {
                      this.adminContent.en.pages.blog.blog_is_active ? this.$route.query.page || this.$router.replace("/salameh/bread?page=1") : this.$router.replace("/404"),
                      this.onResize = this.onResize.bind(this),
                      this.posts = this.computedPosts,
                      this.pages = this.computedPages,
                      this.currentPageIndex = this.computedCurrentPageIndex,
                      this.eventHub.$on("resize", this.onResize)
                  },
                  destroyed: function()
                  {
                      this.eventHub.$off("resize", this.onResize)
                  },
                  mounted: function()
                  {
                      this.eventHub.$emit("page:ready"),
                      this.scrollMeTo('article'),
                      this.onResize()
                  },
                  methods:
                  {
                      onResize: function() {},
                      scrollMeTo(refName) {
                                var element = this.$refs[refName];
                                var _offsetY=(0,getAbsoluteBoundingRect)(element).top;
                                var _fullOffsetY = element.offsetHeight + _offsetY-150;
                                if(this.$route.query.load!=1)
                                  window.scrollTo(0, _fullOffsetY);
                                },
                                scrollMeToApply(p,t) {
                                          this.eventHub.$emit("footer:applyto",p,t)
                  }

                  }
    }

</script>
